export const MEDIA = {
  logo: {
    src: 'https://i.ibb.co/kgj60dnL/logo.webp',
    alt: 'BPAS Business Process Automation Solutions Logo',
    title: 'BPAS Logo'
  },
  hero: {
    src: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&h=600&fit=crop&crop=center',
    alt: 'Professional business team working with automated systems',
    title: 'Business Automation Hero Image'
  },
  services: {
    appointment: {
      src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop&crop=center',
      alt: 'Calendar and scheduling automation system',
      title: 'Appointment Booking Automation'
    },
    chatbot: {
      src: 'https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=400&h=300&fit=crop&crop=center',
      alt: 'AI chatbot interface helping customers',
      title: 'AI Chatbot Solutions'
    },
    crm: {
      src: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop&crop=center',
      alt: 'CRM dashboard showing customer data',
      title: 'CRM Automation Systems'
    },
    website: {
      src: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=400&h=300&fit=crop&crop=center',
      alt: 'Modern responsive website design',
      title: 'Premium Website Design'
    },
    process: {
      src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop&crop=center',
      alt: 'Workflow automation process diagram',
      title: 'Process Automation'
    },
    dashboard: {
      src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop&crop=center',
      alt: 'Business KPI dashboard with charts',
      title: 'Custom Dashboards'
    },
    documents: {
      src: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop&crop=center',
      alt: 'Automated document generation system',
      title: 'Document Automation'
    },
    microsoft: {
      src: 'https://images.unsplash.com/photo-1633356122102-3fe601e05bd2?w=400&h=300&fit=crop&crop=center',
      alt: 'Microsoft Power Platform automation tools',
      title: 'Microsoft Automation'
    }
  },
  blogThumbs: {
    trades: {
      src: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=250&fit=crop&crop=center',
      alt: 'Tradesperson using digital tools',
      title: 'Trades Automation'
    },
    spreadsheets: {
      src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&crop=center',
      alt: 'Spreadsheet being replaced by modern system',
      title: 'Beyond Spreadsheets'
    },
    automation: {
      src: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=400&h=250&fit=crop&crop=center',
      alt: 'Business automation concept',
      title: 'Business Automation'
    },
    crm: {
      src: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop&crop=center',
      alt: 'CRM system for trades',
      title: 'CRM for Trades'
    },
    ndis: {
      src: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop&crop=center',
      alt: 'Healthcare and NDIS provider systems',
      title: 'NDIS Provider Solutions'
    },
    systems: {
      src: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop&crop=center',
      alt: 'Team building business systems',
      title: 'Building Systems'
    },
    leads: {
      src: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=250&fit=crop&crop=center',
      alt: 'Lead generation and enquiry automation',
      title: 'Lead Automation'
    },
    dashboards: {
      src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&crop=center',
      alt: 'KPI dashboard replacing spreadsheets',
      title: 'KPI Dashboards'
    }
  }
};